const getDefaultFiles = (lang) => {
    if (lang === "python") {
        return {
            "ability.py": `from fastapi import FastAPI

# Initialize FastAPI app (main server instance)
app = FastAPI()

# Example GET endpoint exposed to the Ability
@app.get("/example_endpoint")
def example_endpoint(param1: str, param2: int):
    """
    Example endpoint to demonstrate how Ability functions work.

    Parameters:
    - param1: A string parameter passed by the AI
    - param2: An integer parameter passed by the AI

    Returns:
    - A JSON response containing the provided inputs
    """

    return {
        "message": "This is a generic response",
        "param1": param1,
        "param2": param2
    }
`,

            "requirements.txt": `# Python dependencies required to run the Ability server
# fastapi and uvicorn are always required
fastapi
uvicorn
`,

            "runtime.json": `{
        "language": "python",
        "entry": "ability.py",
        "start": "uvicorn ability:app --host 0.0.0.0 --port 5000",

        "description": "Runtime configuration for the Ability server. Defines how the server is started and how the AI can interact with available endpoints.",

        "command_input": [
            {
                "endpoint": "example_endpoint",
                "description": "Defines an endpoint the AI can call, including required parameters and their structure.",
                "parameters": {
                    "param1": {
                        "type": "string",
                        "required": true,
                        "description": "Example string input provided dynamically by the AI"
                    },
                    "param2": {
                        "type": "number",
                        "required": true,
                        "description": "Example numeric input provided dynamically by the AI"
                    }
                }
            }
        ],

        "fields": [
            {
                "endpoint": "example_endpoint",
                "key": "api_key",
                "label": "API Key",
                "type": "string",
                "required": true,
                "description": "Optional value provided by the user during setup (e.g., API keys, URLs, credentials). Stored securely and reused automatically in requests."
            }
        ]
    }`
        };
    }

    if (lang == "javascript") {
        return {
            "ability.js": `const express = require('express');

const app = express();
app.use(express.json());

// Example GET endpoint
app.get('/example_endpoint', (req, res) => {
    /**
     * Example endpoint to demonstrate how Ability functions work.
     * 
     * Query Parameters:
     * - param1: A string parameter passed by the AI
     * - param2: A number parameter passed by the AI
     */

    const { param1, param2 } = req.query;

    res.json({
        message: "This is a generic response",
        param1,
        param2: Number(param2)
    });
});

// Start server
const PORT = process.env.PORT || 8080;

app.listen(PORT, () => {
    console.log("Ability server running");
});
`,

            "package.json": `{
        "name": "Ability",
        "version": "1.0.0",
        "description": "Generic Ability server using Express",
        "main": "ability.js",
        "dependencies": {
            "express": "*"
        }
    }`,

            "runtime.json": `{
        "language": "javascript",
        "entry": "ability.js",
        "start": "node ability.js",

        "description": "Runtime configuration for the Ability server. Defines how the server is started and how the AI can interact with available endpoints.",

        "command_input": [
            {
                "endpoint": "example_endpoint",
                "description": "Defines an endpoint the AI can call, including required parameters and their structure.",
                "parameters": {
                    "param1": {
                        "type": "string",
                        "required": true,
                        "description": "Example string input provided dynamically by the AI"
                    },
                    "param2": {
                        "type": "number",
                        "required": true,
                        "description": "Example numeric input provided dynamically by the AI"
                    }
                }
            }
        ],

        "fields": [
            {
                "endpoint": "example_endpoint",
                "key": "api_key",
                "label": "API Key",
                "type": "string",
                "required": true,
                "description": "Optional value provided by the user during setup (e.g., API keys, URLs, credentials). Stored securely and reused automatically in requests."
            }

        ]
    }`
        };
    }

};

export default getDefaultFiles